module.exports = __webpack_public_path__ + "img/loads-icon-01.2b9f0d2e.gif";